<template>
    <TotemButton :size="size" :color="color" @click="goToLandingPage(url)" :label="label" />
</template>

<script>
    export default {
        name: 'totem-cta-button',
        props: {
            url: String,
            label: String,
            color: {
                type: String,
                default: 'primary'
            },
            size: {
                type: String,
                default: 'medium'
            }
        },
        methods: {
            goToLandingPage (url) {
                if (url === 'trial') {
                    this.$router.push({ name: 'free-subscriptions', params: { slug: this.$t('General.start_trial_url_slug') } })
                } else {
                    window.open(url, '_blank')
                }
            }
        }
    }
</script>
